export default "__VITE_PUBLIC_ASSET__e46afdf9__"